import PropTypes from 'prop-types';
import React from 'react';

function InternalPanelList(props) {
  const { children } = props;

  return (
    <div className="tabbed-content__panel-list">
      { children }
    </div>
  );
}

InternalPanelList.propTypes = {
  children: PropTypes.node.isRequired,
};

export default InternalPanelList;
